import axios from "axios";
import store from '@/store'

// axios.defaults.headers.get['Pragma'] = 'no-cache';
// axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';
axios.defaults.headers = {}

const service = axios.create({
    baseURL:'/api',
    timeout: 86400000,
    headers: {}
    // headers: {
    //     // 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    //     'content-type': "application/json;charset=UTF-8"
    // }
});


service.interceptors.request.use(
    config => {
        if (!config.stopLoading) {
            store.dispatch('loading/setLoadingSpin', true)
        }
        return config;
    },
    error => {
        //console.log(error); // for debug
        store.dispatch('loading/setLoadingSpin', false)
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        store.dispatch('loading/setLoadingSpin', false);
        const { status, data } = response;
        if (response instanceof Blob) {
            return response;
        }
        if (status !== 200) {
            return false;
        } else {
            return data
        }
    },
    error => {
        store.dispatch('loading/setLoadingSpin', false);
        //console.log(error.response);
        return Promise.reject(error.response.data);
    }
);

export default service;